import { useMemo } from "react";

export interface TrelloSourceSettingsText {
  boardLabelText: string;
  boardPlaceholderText: string;
  listsToLoadLabelText: string;
  listsToLoadPlaceholderText: string;
  listsToLoadHintText: string;
  doneListLabelText: string;
  doneListPlaceholderText: string;
  doneListHintText: string;
  assignedToMeLabelText: string;
  labelsFilterLabelText: string;
  labelsFilterPlaceholderText: string;
  labelsFilterHintText: string;
  loadingText: string;
  loadErrorText: string;
  statusReferenceErrorText: string;
}

export const useTrelloSourceSettingsText = (
  t: (key: string) => string,
): TrelloSourceSettingsText => {
  return useMemo(() => {
    const tKey = (key: string): string =>
      t(`board.connections.dialog.sourceSettings.trello.${key}`);

    return {
      boardLabelText: tKey("boardLabel"),
      boardPlaceholderText: tKey("boardPlaceholder"),
      listsToLoadLabelText: tKey("listsToLoadLabel"),
      listsToLoadPlaceholderText: tKey("listsToLoadPlaceholder"),
      listsToLoadHintText: tKey("listsToLoadHint"),
      doneListLabelText: tKey("doneListLabel"),
      doneListPlaceholderText: tKey("doneListPlaceholder"),
      doneListHintText: tKey("doneListHint"),
      assignedToMeLabelText: tKey("assignedToMeLabel"),
      labelsFilterLabelText: tKey("labelsFilterLabel"),
      labelsFilterPlaceholderText: tKey("labelsFilterPlaceholder"),
      labelsFilterHintText: tKey("labelsFilterHint"),
      loadingText: tKey("loading"),
      loadErrorText: tKey("loadError"),
      statusReferenceErrorText: tKey("statusReferenceError"),
    };
  }, [t]);
};
